import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Language as LanguageIcon } from '@material-ui/icons';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../hooks/useTranslation';

const useStyles = makeStyles((theme) => ({
  languageButton: {
    color: 'var(--ikaro-text-white)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  languageButtonLogin: {
    color: 'var(--ikaro-gray-dark)',
    backgroundColor: 'var(--ikaro-text-white)',
    border: '1px solid var(--ikaro-gray-medium)',
    '&:hover': {
      backgroundColor: 'var(--ikaro-gray-light)',
    },
  },
  menuItem: {
    minWidth: 200,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  currentLanguage: {
    backgroundColor: theme.palette.action.selected,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  flag: {
    fontSize: '1.2rem',
    marginRight: theme.spacing(1),
  },
  languageName: {
    fontSize: '0.875rem',
  },
  menuPaper: {
    marginTop: theme.spacing(1),
  },
}));

const LanguageSelector = ({ variant = 'header' }) => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const { supportedLanguages, currentLanguage, changeLanguage } = useLanguage();
  
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = async (languageCode) => {
    await changeLanguage(languageCode);
    handleClose();
  };

  const isLogin = variant === 'login';

  return (
    <>
      <Tooltip title={t('languages.selector') || 'Selecionar idioma'}>
        <IconButton
          className={isLogin ? classes.languageButtonLogin : classes.languageButton}
          onClick={handleClick}
          aria-controls={open ? 'language-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        classes={{
          paper: classes.menuPaper,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top', 
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
      >
        {supportedLanguages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            className={`${classes.menuItem} ${
              currentLanguage === language.code ? classes.currentLanguage : ''
            }`}
          >
            <ListItemIcon className={classes.flag}>
              {language.flag}
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.languageName}>
                  {language.name}
                </Typography>
              }
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector; 